export default (state = true, action) => {
  switch (action.type) {
    case 'CLIENT::ADDING_LICENSE':
      //     console.log('actPay', action.payload)
      return {
        ...state,
        addingLicensePhoto: action.addingLicensePhoto
      }
    default:
      return state
  }
}
